// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.food_tasting_image_status */
var FoodTastingImageStatus;
(function (FoodTastingImageStatus) {
    FoodTastingImageStatus["running"] = "running";
    FoodTastingImageStatus["done"] = "done";
    FoodTastingImageStatus["failed"] = "failed";
})(FoodTastingImageStatus || (FoodTastingImageStatus = {}));
;
export default FoodTastingImageStatus;
/** Zod schema for food_tasting_image_status */
export const foodTastingImageStatus = z.nativeEnum(FoodTastingImageStatus);
//# sourceMappingURL=FoodTastingImageStatus.js.map